import React from 'react';
import { Search, ArrowRight, Ghost } from 'lucide-react';
import { Language } from '../../types';
import { t } from '../../i18n';

interface EmptyStateProps {
    lang: Language;
    title?: string;
    description?: string;
    icon?: React.ElementType;
    actionLabel?: string;
    onAction?: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ 
    lang, 
    title, 
    description, 
    icon: Icon = Ghost,
    actionLabel,
    onAction 
}) => {
    const defaultTitle = t(lang, 'noContentFound');
    const defaultDesc = t(lang, 'noContentDesc');

    return (
        <div className="flex flex-col items-center justify-center py-20 px-6 text-center animate-in fade-in zoom-in duration-500">
            <div className="w-20 h-20 bg-slate-50 rounded-[32px] flex items-center justify-center text-slate-200 mb-6">
                <Icon size={40} />
            </div>
            <h3 className="text-xl font-black text-slate-900 uppercase tracking-tight mb-3">
                {title || defaultTitle}
            </h3>
            <p className="text-sm font-medium text-slate-400 max-w-xs leading-relaxed mb-6">
                {description || defaultDesc}
            </p>
            {/* <div className="mb-10 p-4 bg-slate-50 rounded-2xl border border-slate-100 max-w-md">
                <p className="text-[10px] text-slate-400 leading-normal">
                    {t(lang, 'emptyStateIntelligence')}
                </p>
            </div> */}
            {onAction && actionLabel && (
                <button 
                    onClick={onAction}
                    className="flex items-center gap-2 px-6 py-3 bg-slate-900 text-white rounded-full text-xs font-black uppercase tracking-widest md:hover:bg-rose-500 transition-all active:scale-95"
                >
                    {actionLabel}
                    <ArrowRight size={14} />
                </button>
            )}
        </div>
    );
};
